<template>
  <!-- <lottie-player
    autoplay
    loop
    :src="src"
    :style="computedStyle"
    :class="[ns.b()]"
    data-test-name="lottie"
    data-test-variant=""
    data-test-state=""
  /> -->
  <div>Deprecated component</div>
</template>

<script lang="ts" setup>
// import { computed } from 'vue'
// import { isClient } from '@vueuse/core'
// import { isNumber } from '@bigin/utils'
// import { useNamespace } from '@bigin/hooks'
// import { lottieProps } from './lottie'

// isClient && import('@lottiefiles/lottie-player')

defineOptions({
  name: 'BLottie',
})

// const props = defineProps(lottieProps)
// const ns = useNamespace('lottie')
// const computedStyle = computed(() => {
//   const style = {} as { width?: string; height?: string }

//   if (isNumber(props.width) && props.width > 0) style.width = `${props.width}px`
//   if (isNumber(props.height) && props.height > 0)
//     style.width = `${props.height}px`

//   return style
// })
</script>
